//Mitt for replacing event bus because vue2 doesn't support event bus
import mitt from 'mitt'
export default mitt()
